/** Client HTTP unique — seule responsabilité : parler à `/api` et normaliser les erreurs. */

export class ApiError extends Error {
  constructor(
    readonly status: number,
    message: string,
    readonly issues?: unknown,
  ) {
    super(message);
    this.name = "ApiError";
  }
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const isForm = init?.body instanceof FormData;
  // Ne fixer Content-Type: application/json QUE s'il y a un vrai corps JSON.
  // Sinon (DELETE, POST sans données) Fastify refuse un corps vide en 400.
  const jsonBody = init?.body != null && !isForm;
  const res = await fetch(`/api${path}`, {
    credentials: "same-origin",
    ...init,
    headers: jsonBody
      ? { "Content-Type": "application/json", ...(init?.headers ?? {}) }
      : (init?.headers ?? {}),
  });
  const isJson = res.headers.get("content-type")?.includes("application/json");
  const body = isJson ? await res.json() : undefined;
  if (!res.ok) throw new ApiError(res.status, body?.error ?? res.statusText, body?.issues);
  return body as T;
}

export const http = {
  get: <T>(path: string) => request<T>(path),
  post: <T>(path: string, data?: unknown) =>
    request<T>(path, {
      method: "POST",
      body: data === undefined ? undefined : JSON.stringify(data),
    }),
  patch: <T>(path: string, data?: unknown) =>
    request<T>(path, { method: "PATCH", body: JSON.stringify(data) }),
  del: <T>(path: string) => request<T>(path, { method: "DELETE" }),
};
